import { render, staticRenderFns } from "./PurchaseAndSaleTable.vue?vue&type=template&id=2a638362&scoped=true"
import script from "./PurchaseAndSaleTable.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSaleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a638362",
  null
  
)

export default component.exports